import React from "react";
import "./input.css";

export default function Input(props) {
  const {
    placeholder,
    maxLength = -1,
    className = "",
    value = "",
    onChange,
    onBlur,
    style = {},
  } = props;

  function handleInputChange(event) {
    const value = (event.target.value || "").trim();
    onChange && onChange(value);
  }

  function handleInputBlur(event) {
    const value = (event.target.value || "").trim();
    onBlur && onBlur(value);
  }

  return (
    <input
      style={style}
      className={`app-input ${className}`}
      type="text"
      placeholder={placeholder}
      maxLength={maxLength}
      autoComplete="off"
      value={value}
      onChange={handleInputChange}
      onBlur={handleInputBlur}
    />
  );
}
